<template>
    <div class="row" style="padding:6px;">
        <modal-confirm :show="showConfirm" @onselect="onConfirmSelection">
            <div style="color: red;">
                <h4>Invalid url: {{ reqObj.value }}</h4>
                <div>Select Again?</div>
            </div>
        </modal-confirm>
        <div class="col-xs-12">
            <div style="width:100%;">
                <img :src="entry.imgThumb" style="width:100px;height:auto;" />
                {{ entry.linkImg }}
            </div>
        </div>
        <div class="col-xs-12">
            <div style="display: flex;flex-direction:row;">
                <div>
                    {{ lang.postLink.linkType }}:
                    <select v-model="entry.linkType" class="form-control">
                        <option value="0">{{ lang.postLink.web }}</option>
                        <option value="1">{{ lang.postLink.youtubeLink }}</option>
                    </select>
                </div>
                <div style="width: 60px;">{{ lang.common.seq }}:<input class="form-control" type="text"
                        v-model="entry.seq" /></div>
                <!-- <div>
                    __
                    <button class="form-control" v-on:click="$emit('setimgclicked', entry)">{{ lang.postLink.setImage
                        }}</button>
                </div> -->
            </div>

            <div>{{ lang.postLink.linkUrl }}:</div>
            <div style="display: flex;flex-direction: row;">
                <input class="form-control" type="text" v-model="entry.linkUrl" /><button @click="selectLink"
                    class="btn btn-default">{{ lang.common.select }}</button>
            </div>
            <div>{{ lang.postLink.linkTitle }}:</div>
            <input class="form-control" type="text" v-model="entry.linkTitle" />
            <div>{{ lang.common.content }}:</div>
            <textarea class="form-control" v-model="entry.linkText" />
            <div class="col-xs-12" style="padding: 6px;">
                <input type="button" :value="lang.common.remove" v-if="showRemove"
                    v-on:click="$emit('removeclicked', entry)" class="btn btn-danger" />
                <input type="button" :value="lang.common.update" v-if="showUpdate" class="btn btn-primary"
                    style="float:right;" v-on:click="$emit('updateclicked', entry)" />
                <input type="button" :value="lang.common.create" v-if="showCreate" class="btn btn-primary"
                    style="float:right;" v-on:click="$emit('createclicked', entry)" />
            </div>
        </div>
    </div>
</template>
<script>
import imageList from './imageList.vue';
import modalX from '../components/base/ModalX.vue';
import modalConfirm from '../components/base/ModalConfirm.vue';
import apis from '../api/extApi.js';

export default {
    components: {
        imageList: imageList,
        modalX: modalX,
        modalConfirm: modalConfirm
    },
    props: {
        "postId": String,
        "initData": { type: Object, default: null },
        "showCreate": { type: Boolean, default: true },
        "showUpdate": { type: Boolean, default: true },
        "showRemove": { type: Boolean, default: true }
    },
    computed: {
        lang: function () {
            return this.$store.getters.lang;
        }
    },
    data: function () {
        return {
            apiClient: apis.api,
            uiClient: null,
            imgHandler: null,
            isSelectingImage: false,
            selectedImgs: [],
            reqObj: { type: "youtube", value: "https://www.youtube.com" },
            showConfirm: false,
            entry: this.initData === null ? { linkType: 1, linkUrl: null, linkText: null, linkTitle: null, postId: this.postId, seq: 0, linkImg: null } : this.initData
        };
    },
    methods: {
        save: function () {
            this.$emit("onsave", this.entry);
        },
        onImgSelect: function (imgFile) {
            this.selectedImgs.push(imgFile);
            this.imgHandler(imgFile, this.selectedImgs);
        },
        setNewLabelImg: function (newImg) {
            //this.newLabel.frnImgPath = newImg.thumbPath;
            this.entry.linkImg = newImg.fileName + newImg.fileType;
            this.isSelectingImage = false;
        },
        selectImg: function (handler) {
            this.imgHandler = handler;
            this.isSelectingImage = !this.isSelectingImage;
        },
        onConfirmSelection: function (positive) {
            this.showConfirm = false;
            if (positive) {
                this.selectLink();
            }
        },
        selectLink: function () {
            let reqObj = this.reqObj;
            let makeReq = (req) => {
                let prm = this.mxnRequestPrm(req);
                prm.then((ret) => {
                    console.log("on select Link result 2", ret);
                    if (isWatchUrl(ret.payload)) {
                        this.entry.linkUrl = ret.payload;
                    } else {
                        //makeReq({...reqObj, value:ret.payload});
                        this.reqObj = { ...reqObj, value: ret.payload };
                        this.showConfirm = true;
                    }
                });
            }

            function isWatchUrl(url) {
                const watchPattern = /\/watch\?v=/;
                return watchPattern.test(url);
            }

            makeReq(reqObj);
        }
    },
    created: function () {

    },
    mounted: function () {
        //this.uiClient = apis.ui.getShopClient({ userId: this.shopUserId });
    },
    destroyed: function () {
        //this.uiClient.destroy();
    }
}
</script>